import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "Container Container--narrow lg:mb-40" }
const _hoisted_2 = {
  key: 1,
  class: "text-red-600 py-4 text-center"
}

import { ref } from 'vue';
import { Form } from 'vee-validate';
import { initialValues } from './initialValues';
import { scrollToTop } from '../../helpers/scrollToTop';
import { schema } from './schema';
import SearchPesel from './SearchPesel.vue';
import VisitTracker from './VisitTracker.vue';


export default {
  __name: 'StatusSearch',
  setup(__props) {

const isLoading = ref(false);
const isError = ref(false);

const orderData = ref([]);

const onSearchClick = (data) => {
    isLoading.value = true;
    isError.value = false;
    orderData.value = [];

    const formData = new FormData();
    formData.append('action', 'get_visit_statuses');
    formData.append('pesel', data.pesel);

    fetch(jsData.ajaxUrl, {
        method: 'POST',
        body: formData,
    })
        .then((response) => {
            isLoading.value = false;
            return response.json();
        })
        .then((response) => {
            if (response.data.length) {
                orderData.value = response.data[0];
            } else {
                isError.value = true;
            }
        })
        .catch(() => {
            isError.value = true;
        });
};

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(Form), {
    "initial-values": _unref(initialValues),
    "validation-schema": _unref(schema),
    enctype: "multipart/form-data",
    class: "erecepta-form",
    onInvalidSubmit: _unref(scrollToTop),
    onSubmit: onSearchClick,
    onKeydown: _cache[0] || (_cache[0] = _withKeys($event => ($event.preventDefault()), ["enter"]))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SearchPesel, { loading: isLoading.value }, null, 8, ["loading"]),
        (Object.keys(orderData.value).length)
          ? (_openBlock(), _createBlock(VisitTracker, {
              key: 0,
              orderData: orderData.value
            }, null, 8, ["orderData"]))
          : _createCommentVNode("", true),
        (isError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Niestety nie możemy znaleźć Twojej wizyty w systemie. "))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["initial-values", "validation-schema", "onInvalidSubmit"]))
}
}

}